import { NgClass } from '@angular/common';
import {
	AfterViewInit,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	ElementRef,
	input,
	output,
	QueryList,
	ViewChild,
	ViewChildren,
} from '@angular/core';
import { EntitiesPipe } from '@uc/utilities';

@Component({
	selector: 'uc-campus-card-navigation',
	templateUrl: './campus-card-navigation.component.html',
	imports: [NgClass, EntitiesPipe],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CampusCardNavigationComponent implements AfterViewInit {
	navigationItems = input<string[]>([]);
	selectIndex = output<number>();
	@ViewChildren('elements') elements!: QueryList<ElementRef<HTMLElement>>;
	@ViewChild('container') container!: ElementRef<HTMLDivElement>;
	@ViewChild('scrollContainer') scrollContainer!: ElementRef<HTMLDivElement>;
	displayButton = false;
	selectedIndex = 0;

	private _containerWidth = 0;
	private _scrollIndex = 0;
	private _gap = 24;
	private _buttonWidth = 116;

	constructor(private _cd: ChangeDetectorRef) {}

	ngAfterViewInit() {
		this._containerWidth =
			this.container.nativeElement.scrollWidth - this._buttonWidth;
		this.displayButton =
			this._containerWidth < this.scrollContainer.nativeElement.scrollWidth;
		this._cd.detectChanges();
	}

	onScrollContainer(direction: 'left' | 'right') {
		const item = this.elements.toArray()[this._scrollIndex];
		if (
			!item?.nativeElement ||
			!this.container?.nativeElement ||
			!this.scrollContainer?.nativeElement
		)
			return;

		const elementWidth = item.nativeElement.scrollWidth + this._gap;

		if (
			direction === 'right' &&
			this._containerWidth < this.scrollContainer.nativeElement.scrollWidth
		) {
			this.scrollContainer.nativeElement.scrollLeft += elementWidth;
			this._scrollIndex++;
			this._containerWidth += elementWidth;
		} else if (
			direction === 'left' &&
			this._containerWidth > this.container.nativeElement.scrollWidth
		) {
			this.scrollContainer.nativeElement.scrollLeft -= elementWidth;
			this._scrollIndex--;
			this._containerWidth -= elementWidth;
		}
	}
}
